import { Badge } from '@repo/ui/components/Badge';
import { useNewThemeActive } from '@repo/ui/theming';
import capitalize from 'lodash/capitalize';

import useFreeTrial from '../../../hooks/useFreeTrial';
import Tag from '../../Tag/Tag';
import { specialTheme } from '../../Tag/theme';

import { AccountTagProps } from './types';

const AccountTag: React.FC<AccountTagProps> = ({ team, user }) => {
  const { isRunning: isFreeTrialRunning } = useFreeTrial();

  const isNewThemeActive = useNewThemeActive();

  let tag = 'FREE';
  if (team?.plan) {
    tag = team.plan;
  } else if (isFreeTrialRunning && !team) {
    tag = 'TRIAL';
  } else if (user?.plan) {
    tag = user.plan;
  }

  return isNewThemeActive ? (
    <Badge text={capitalize(tag)} variant="blue" />
  ) : (
    <Tag theme={specialTheme}>{tag}</Tag>
  );
};

export default AccountTag;
